var map = {
	"./img_scada_data00.png": 54806,
	"./img_scada_data01.png": 8607,
	"./img_scada_data02.png": 23332,
	"./img_scada_data03.png": 86573,
	"./img_scada_data04.png": 56594,
	"./img_scada_data05.png": 78139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53968;